import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import '../styles/register.css';

const AuthErrorPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const message = searchParams.get('message') || 'Authentication failed. Please try again.';

  return (
    <section className="register-page">
      <div className="register-shell register-shell-single">
        <div className="register-panel register-panel-form register-status-panel">
          <div className="register-status-badge register-status-badge-error">Auth Error</div>
          <h1 className="register-form-title">We could not complete sign in</h1>
          <p className="register-form-copy">{message}</p>
          <div className="register-status-actions">
            <Link className="register-submit register-submit-inline" to="/register">
              Back to registration
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuthErrorPage;
